// extracted by mini-css-extract-plugin
export default {"labeledContainer":"LabeledContainer_labeledContainer__oK31I"};